module.exports = __webpack_public_path__ + "static/Eros-333e5040dbe0d2ce99092eea1616de2c.png";